import { render } from "./ErrorDialog.vue?vue&type=template&id=56efb430&ts=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts"

import "./ErrorDialog.vue?vue&type=style&index=0&id=56efb430&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__